'use client';

import React from 'react';
import { useBayonet, useEvent } from '@/store';
import Script from 'next/script';

function Bayonet() {
    const { setBayonetCurrentToken } = useBayonet();
    const initBayonet = () => {
        if (!process.env.NEXT_PUBLIC_BAYONET_JS_KEY) return console.error('Please provide bayonet public API key');
        _bayonet.init({
            js_key: process.env.NEXT_PUBLIC_BAYONET_JS_KEY,
            callback_function: bayonetInitCallback
        });
        _bayonet.track();
    }

    const bayonetInitCallback = (response) => {
        setBayonetCurrentToken(response.bayonet_fingerprint_token);
    }
    return (
        <>
            <Script onLoad={initBayonet} src="https://cdn.bayonet.io/fingerprinting-2.0.min.js" async></Script>
        </>
    );
}

export default Bayonet;
